import React from "react";
import { FormGroup, Modal, ModalHeader, ModalFooter } from "reactstrap";
import SpinnerButton from "../Button";

function ModalDeleteAlert({ toggle, handleDeleteAlerta }) {
  return (
    <Modal centered backdrop="static" isOpen toggle={toggle}>
      <FormGroup>
        <ModalHeader className="text-center" toggle={toggle}>
          ¿Desea Eliminar esta alerta del listado? Además esto tendrá impacto en la calendarización del mes siguiente
        </ModalHeader>
        <ModalFooter>
          <div className="mb-0 px-3 w-100 d-flex justify-content-between">
            <SpinnerButton className="btn btn-light" type="button" onClick={toggle}>
              Cancelar
            </SpinnerButton>
            <SpinnerButton className="btn btn-primary" type="button" onClick={handleDeleteAlerta}>
              Confirmar
            </SpinnerButton>
          </div>
        </ModalFooter>
      </FormGroup>
    </Modal>
  );
}

export default ModalDeleteAlert;
